<script land="ts">
  import { copy } from "../lib/stores/copy";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import { urls } from "../lib/constants/urls";
  import { qualifyingPurchase } from "../lib/constants/qualifyingPurchase";
</script>

<footer class="relative px-[16px] bg-dark z-[1]">
  <div class="relative flex items-end justify-center py-[24px] mx-auto w-full laptop:px-[230px]">
    <div class="absolute flex items-center tabletLg:justify-start w-full z-[10] tabletLg:left-0 bottom-full laptop:bottom-[auto] h-[105px]">
      <img class="h-full w-full object-contain object-left" src={$copy.footer.pattern} alt="">
    </div>
    <div class="max-w-[1000px] desktopLg:max-w-[1400px]">
      <div class:hidden={!isPrimaryCampaign}>
        <div class="flex items-center justify-center mb-[24px]">
          <div class="flex items-center justify-center mx-[8px]">
            <a 
              href={$urls.social.twitter}
              class="std-social__link flex items-center justify-center w-full max-w-[28px] text-white"
              target="_blank"
              aria-label="twitter"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1199.999 1226.37"
              >
                <path d="M569.165 687.854v-.026l-47.469-67.894L144.01 79.694h162.604l304.798 435.991 47.468 67.894 396.2 566.721H892.476ZM1055.03 0 667.136 450.887 357.327 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.18 476.152h357.328L714.137 519.284h.025L1160.89 0Z" fill="currentColor" />
              </svg>
            </a>
          </div>
          <div class="flex items-center justify-center mx-[8px]">
            <a 
              href={$urls.social.facebook}
              class="std-social__link flex items-center justify-center w-full max-w-[32px] text-white"
              target="_blank"
              aria-label="facebook"
            >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 498.169"><defs><clipPath id="a"><path d="M0 0h500v500H0z" style="fill:none"/></clipPath></defs><g data-name="Layer 2"><g data-name="Layer 1"><path d="M500 250C500 111.929 388.071 0 250 0S0 111.929 0 250c0 117.245 80.715 215.622 189.606 242.638V326.396h-51.552V250h51.552v-32.919c0-85.092 38.508-124.532 122.048-124.532 15.838 0 43.167 3.105 54.347 6.211v69.254c-5.901-.621-16.149-.932-28.882-.932-40.993 0-56.832 15.528-56.832 55.9V250h81.659l-14.028 76.396h-67.631v171.773C404.073 483.218 500 377.818 500 250" fill="currentColor" /></g></g></svg>
            </a>
          </div>
          <div class="flex items-center justify-center mx-[8px]">
            <a 
              href={$urls.social.instagram}
              class="std-social__link flex items-center justify-center w-full max-w-[32px] text-white"
              target="_blank"
              aria-label="instagram"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 999.99989 1000.00002"><defs><clipPath id="clip-path" transform="translate(-0.00034 -0.00022)"><rect class="cls-1" width="1000" height="1000"/></clipPath></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g class="cls-2"><path fill="currentColor" d="M292.92328,3.46271c-53.201,2.511-89.537,11.032-121.29,23.474-32.869,12.814-60.733,29.987-88.451,57.819-27.751,27.848-44.794,55.761-57.51,88.663-12.312,31.834-20.656,68.187-23.005,121.421-2.332,53.332-2.867,70.342-2.607,206.116.259,135.758.858,152.8,3.401,206.148,2.543,53.186,11.033,89.507,23.474,121.275,12.831,32.87,29.986,60.718,57.834,88.453,27.832,27.735,55.76,44.762,88.679,57.495,31.801,12.296,68.169,20.672,121.387,23.004,53.33,2.35,70.356,2.868,206.097,2.609,135.804-.259,152.831-.859,206.161-3.386,53.201-2.544,89.505-11.065,121.29-23.474,32.87-12.863,60.733-29.987,88.451-57.835,27.719-27.832,44.761-55.762,57.479-88.68,12.312-31.801,20.687-68.171,23.004-121.356,2.332-53.364,2.884-70.407,2.624-206.165-.259-135.774-.874-152.784-3.402-206.099-2.527-53.234-11.048-89.539-23.474-121.324-12.846-32.87-29.986-60.702-57.817-88.453-27.832-27.719-55.761-44.794-88.679-57.478-31.817-12.313-68.17-20.705-121.388-23.00495-53.33-2.365-70.356-2.88305-206.145-2.624-135.756.259-152.782.842-206.113,3.402m5.833,903.876c-48.747-2.122-75.217-10.222-92.859-17.01-23.361-9.04-40.03-19.878-57.575-37.293-17.512-17.48-28.383-34.102-37.503-57.414-6.853-17.642-15.099-44.081-17.383-92.827-2.479-52.7-3.045-68.511-3.288-202.017-.259-133.474.226-149.285,2.527-202.033,2.089-48.715,10.239-75.218,17.01-92.84405,9.039-23.393,19.844-40.03095,37.292-57.575,17.48-17.545,34.101-28.384,57.429-37.504,17.626-6.885,44.065-15.067,92.794-17.383,52.731-2.495,68.526-3.03,201.998-3.289,133.504-.259,149.316.211,202.064,2.528,48.712,2.122,75.215,10.19,92.825,17.01,23.377,9.039,40.047,19.813,57.576,37.293,17.528,17.48,28.398,34.069,37.519,57.446,6.884,17.577,15.065,44.048,17.366,92.762,2.511,52.732,3.078,68.543,3.321,202.017.259,133.507-.227,149.318-2.543,202.033-2.122,48.747-10.207,75.234-17.01,92.893-9.04,23.344-19.846,40.014-37.31,57.559-17.462,17.48-34.084,28.383-57.428,37.504-17.59406,6.868-44.064,15.066-92.762,17.383-52.73,2.478-68.526,3.045-202.047,3.288-133.472.259-149.266-.243-202.013-2.527m407.609-674.61a59.9966,59.9966,0,1,0,59.875-60.103,59.99768,59.99768,0,0,0-59.875,60.103m-463.094,267.757c.275,141.801,115.441,256.499,257.207,256.223,141.783-.275,256.543-115.41,256.269-257.211-.276-141.752-115.45794-256.515-257.25695-256.239-141.767.275-256.495,115.459-256.219,257.227m90.055-.178a166.66628,166.66628,0,1,1,166.974,166.344,166.669,166.669,0,0,1-166.974-166.344" transform="translate(-0.00034 -0.00022)"/></g></g></g></svg>
            </a>
          </div>
          <div class="flex items-center justify-center mx-[8px]">
            <a 
              href={$urls.social.youtube}
              class="std-social__link flex items-center justify-center w-full max-w-[42px] text-white"
              target="_blank"
              aria-label="youtube"
            >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.485 85.039"><defs><clipPath id="a"><path d="M0 0h121.485v85.039H0z" style="fill:none"/></clipPath></defs><g data-name="Layer 2"><g data-name="Layer 1"><path d="M118.946 13.279a15.214 15.214 0 0 0-10.74-10.741C98.732 0 60.742 0 60.742 0s-37.99 0-47.463 2.538a15.214 15.214 0 0 0-10.74 10.741c-2.54 9.474-2.54 29.24-2.54 29.24S0 62.286 2.54 71.76a15.213 15.213 0 0 0 10.74 10.74c9.474 2.539 47.463 2.539 47.463 2.539s37.99 0 47.464-2.539a15.213 15.213 0 0 0 10.74-10.74c2.539-9.474 2.539-29.241 2.539-29.241s0-19.766-2.54-29.24M48.595 60.742V24.297l31.56 18.223Z" fill="currentColor" /></g></g></svg>
            </a>
          </div>
          <div class="flex items-center justify-center mx-[8px]">
            <a 
              href={$urls.social.tiktok}
              class="std-social__link flex items-center justify-center w-full max-w-[28px] text-white"
              target="_blank"
              aria-label="tiktok"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.866 17.781"><defs><clipPath id="a"><path d="M0 0h15.866v17.781H0z" style="fill:none"/></clipPath></defs><g data-name="Layer 2"><g data-name="Layer 1" style="clip-path:url(#a)"><path d="M9.293 13.027A2.603 2.603 0 0 1 6.67 15.5a2.665 2.665 0 0 1-.92-.163 2.665 2.665 0 0 0 .92.163 2.603 2.603 0 0 0 2.624-2.473L9.298.776h2.29a4.26 4.26 0 0 0 1.908 2.788h.001a4.397 4.397 0 0 0 2.37.69V7.31a7.555 7.555 0 0 1-4.353-1.368v6.213a5.699 5.699 0 0 1-5.757 5.626 5.817 5.817 0 0 1-3.299-1.02l-.002-.001A5.587 5.587 0 0 1 0 12.154a5.7 5.7 0 0 1 5.757-5.627 6.006 6.006 0 0 1 .776.055v.724a5.717 5.717 0 0 0-5.586 4.997 5.716 5.716 0 0 1 5.586-4.996v2.397a2.65 2.65 0 0 0-.776-.12 2.603 2.603 0 0 0-2.629 2.57 2.565 2.565 0 0 0 1.41 2.275 2.658 2.658 0 0 0 1.22.295A2.603 2.603 0 0 0 8.38 12.25L8.386 0h3.128a4.141 4.141 0 0 0 .074.776h-2.29Z" fill-rule="evenodd" fill="currentColor" /></g></g></svg>
            </a>
          </div>
        </div>
      </div>
      <ul class="footer-nav flex items-center justify-center flex-wrap w-full max-w-[340px] mb-[6px] mobileS:max-w-[380px] mx-auto tablet:w-auto tablet:max-w-full">
        <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px]">
          <a 
            href="#prizes"
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.rewardsAndPrizes}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.rewardsAndPrizes}
          </a>
        </li>
        <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
          <a 
            href={$urls.officialRules}
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.officialRules}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.officialRules}
          </a>
        </li>
        {#if $urls.nonParticipatingStores}
          <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
            <a 
              href={$urls.nonParticipatingStores}
              class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
              target="_blank"
              aria-label={$copy.footer.ariaLabels.navigation.nonParticipatingStores}
              rel="noopener noreferrer"
            >
              {$copy.footer.navItems.nonParticipatingStores}
            </a>
          </li>
        {/if}
        <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
          <a 
            href="#faq"
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.faq}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.faq}
          </a>
        </li>
        <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
          <a 
            href={$urls.termsOfService}
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.termsOfService}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.termsOfService}
          </a>
        </li>
        <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
          <a 
            href={$urls.privacyPolicy}
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.privacyPolicy}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.privacyPolicy}
          </a>
        </li>
        {#if $urls.usStatePrivacyPolicy}
          <li class="footer-nav__item flex justify-center relative mr-[6px] mb-[6px] ml-[6px]">
            <a 
              href={$urls.usStatePrivacyPolicy}
              class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
              target="_blank"
              aria-label={$copy.footer.ariaLabels.navigation.usStatePrivacyPolicy}
              rel="noopener noreferrer"
            >
              {$copy.footer.navItems.usStatePrivacyPolicy}
            </a>
          </li>
        {/if}
        <li class="footer-nav__item flex justify-center relative mb-[6px] ml-[6px]">
          <a 
            href={$urls.contactUs}
            class="footer-nav__link font-MrEavesXLSanNarOT text-[18px] text-white no-underline whitespace-nowrap leading-[1.1] font-medium"
            target="_blank"
            aria-label={$copy.footer.ariaLabels.navigation.contactUs}
            rel="noopener noreferrer"
          >
            {$copy.footer.navItems.contactUs}
          </a>
        </li>
      </ul>
      <div class="text-[12px] text-white text-center font-medium">
        <p class="mb-[12px]">
          *{$qualifyingPurchase}
          {@html $copy.footer.info}
        </p>
        <p>
          {@html $copy.footer.copyright}
        </p>
      </div>
    </div>  
  </div>
</footer>
